<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
        window.entryUrl = window.location.href
      }
  },
  mounted() {

  },
  methods: {}
}
</script>
<style>
* {
  padding: 0;
  margin: 0;
}

body {
  font: 12px Arial, "PingFang SC", "Hiragino Sans GB", STHeiti,
    "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  font-family: "Microsoft YaHei,Microsoft YaHei-Regular";

  background-color: #f6f8fa;
}

[v-cloak] {
  display: none;
}

img[src=""] img:not([src]) {
  opacity: 0;
}

#app {
  width: 100%;
  height: 100%;
}
.el-dialog__header {
    padding: 0 !important;

}


#nprogress .bar {
  background: #d0a48d !important;
}

a {
  text-decoration: none;
}

body::-webkit-scrollbar {
  width: 6px;
  flex: 1;
}

body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px #d8d8d8;
  background: #535353;
}

body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px #d8d8d8;
  border-radius: 10px;
  background: #ededed;
}
.mce-panel{
  border-radius: 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue